"use client";

import { cn } from "@/lib/utils";

export function Marquee({
  className,
  reverse = false,
  pauseOnHover = false,
  vertical = false,
  repeat = 4,
  duration = "40s",
  gap = "1rem",
  children,
  ...props
}) {
  const repeatedChildren = Array(repeat)
    .fill(0)
    .map((_, i) => (
      <div
        key={i}
        className={cn(
          "flex shrink-0",
          vertical ? "flex-col" : "flex-row",
        )}
        style={{ gap }}
      >
        {children}
      </div>
    ));

  const group = (
    <div
      className={cn(
        "flex shrink-0",
        vertical ? "flex-col" : "flex-row",
      )}
      style={{ gap }}
    >
      {repeatedChildren}
    </div>
  );

  return (
    <>
      {/* Inline CSS */}
      <style>{`
        @keyframes marquee {
          from { transform: translateX(0); }
          to { transform: translateX(calc(-50% - (${gap} / 2))); }
        }
        @keyframes marquee-vertical {
          from { transform: translateY(0); }
          to { transform: translateY(calc(-50% - (${gap} / 2))); }
        }

        .marquee {
          display: flex;
          flex-shrink: 0;
          width: max-content;
          animation-name: marquee;
          animation-timing-function: linear;
          animation-iteration-count: infinite;
        }

        .marquee-vertical {
          display: flex;
          flex-shrink: 0;
          flex-direction: column;
          animation-name: marquee-vertical;
          animation-timing-function: linear;
          animation-iteration-count: infinite;
        }

        .marquee-hover:hover,
        .marquee-vertical-hover:hover {
          animation-play-state: paused;
        }
      `}</style>

      <div
        {...props}
        className={cn(
          "overflow-hidden flex",
          vertical ? "flex-col" : "flex-row",
          className,
        )}
      >
        <div
          className={cn(
            vertical
              ? pauseOnHover
                ? "marquee-vertical-hover marquee-vertical"
                : "marquee-vertical"
              : pauseOnHover
                ? "marquee-hover marquee"
                : "marquee",
          )}
          style={{
            gap,
            animationDuration: duration,
            animationDirection: reverse ? "reverse" : "normal",
          }}
        >
          {group}
          {group}
        </div>
      </div>
    </>
  );
}
